<template>
    <div id="product_main" class="ui centered container">
        <div class="ui bottom fixed menu">
            <div class="center menu">
                <div class="item" v-for="center in getCenters()" :key="center._id">
                    {{ center.name }}
                </div>
            </div>
        </div>
        <div class="ui segment">
            <div class="ui text menu">
                <div class="menu">
                    <div class="item">
                        <div v-if="alivePartners && alivePartners.length > 0" class="ui form">
                            <div class="field">
                                <select class="ui simple dropdown" v-model="partnerId" @change="updateProducts">
                                    <option v-for="p in alivePartners" :key="p._id" :value="p._id">{{ p.name }}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="item">
                        <div class="ui form">
                            <select class="ui simple dropdown" v-model="sortType">
                                <option :value="'이름순'">이름순</option>
                                <option :value="'이름역순'">이름역순</option>
                                <option :value="'날짜순'">날짜순</option>
                                <option :value="'날짜역순'">날짜역순</option>
                            </select>
                        </div>
                    </div>
                    <div class="item">
                        <div class="ui form">
                            <select class="ui simple dropdown" v-model="filterStock">
                                <option :value="'재고유무'">재고유무</option>
                                <option :value="'재고유'">재고 유</option>
                                <option :value="'재고무'">재고 무</option>
                            </select>
                        </div>
                    </div>
                    <div class="item">
                        <div class="ui form">
                            <div class="ui checkbox">
                                <input type="checkbox" v-model="isTerminated">
                                <label>판매종료</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="right menu">
                    <div v-if="isHeader" class="item">
                        <div class="ui primary small button" @click="setStock()">재설정</div>
                    </div>
                    <div class="item">
                        <div v-if="!isCenter" class="ui primary small button" @click="newProduct">상품 추가</div>
                    </div>
                    <div class="item">
                        <div class="ui teal small button" @click="openProductStockLog">날짜별 보기</div>
                    </div>
                    <div class="item">
                        <div class="ui teal small button" @click="download">다운로드</div>
                    </div>
                    <div class="item">
                        <div class="ui teal small button" @click="downloadAll">전체 다운로드</div>
                    </div>
                    <div class="item">
                        <div class="ui orange small button" @click="updateProducts">새로고침</div>
                    </div>
                </div>
            </div>
            <!-- <table class="ui selectable head stuck unstackable celled compact table"> -->
            <table class="ui selectable celled compact table">
                <thead>
                    <tr>
                        <th class="collapsing">#</th>
                        <th class="collapsing">등록날짜</th>
                        <th>규격</th>
                        <th>상품명</th>
                        <th v-for="center in getCenters()" :key="center._id">{{ center.name }}</th>
                        <th>합계</th>
                        <th class="collapsing">정산</th>
                        <th></th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(product, index) in getProducts()" :key="product._id">
                        <td class="collapsing">{{ index+1 }}</td>
                        <td class="collapsing">{{ new Date(product.createdAt).format("yy/MM/dd") }}</td>
                        <td>{{ product.description }}</td>
                        <td>{{ product.name }}</td>
                        <td v-for="center in getCenters()" :key="center._id">
                            {{ product.centerStocks[center._id] ? product.centerStocks[center._id].count : 0 }}
                        </td>
                        <td>
                            {{ product.totalCount }}
                        </td>
                        <td class="right collapsing">
                            <i class="truck icon" v-if="product.normalCalculate"></i>
                            <i class="box icon" v-if="product.parcelCalculate"></i>
                            <i class="home icon" v-if="product.centerCalculate"></i>
                            <i class="user icon" v-if="product.workerCalculate"></i>
                        </td>
                        <td class="right collapsing">
                            <button v-if="isHeader" class="ui small basic button" @click="transferStock(product)">이관</button>
                        </td>
                        <td class="right collapsing">
                            <div class="ui small icon buttons">
                                <button :class="product == selected ? 'ui grey button' : 'ui basic button'" @click="editProduct(product)" :disabled="isCenter">
                                    <i class="edit icon"></i>
                                </button>
                                <button class="ui basic button " @click="removeProduct(product)" :disabled="!isHeader">
                                    <i class="trash icon"></i>
                                </button>
                            </div>
                        </td>
                    </tr>
                    <tr v-if="filterStock == '재고유무' || filterStock == '재고유'">
                        <td></td>
                        <td></td>
                        <td></td>
                        <td>전체합계</td>
                        <td v-for="center in getCenters()" :key="center._id">
                            {{ centerTotalCounts[center._id] }}
                        </td>
                        <td>{{ getAllTotalCount() }}</td>
                    </tr>
                </tbody>
                <tfoot>
                    <div class="ui hidden divider"></div>
                    <div class="ui hidden divider"></div>
                </tfoot>
            </table>
        </div>
    </div>
</template>

<script>
export default {
    data: function() {
        return {
            partnerId: 0,
            centerTotalCounts: 0,
            filterStock: 0,
            sortType: 0,
            selected: 0,
            isTerminated: 0,
            products: [],
            alivePartners: [],
        };
    },
    mounted: function() {
        this.alivePartners = this.getAlivePartners();
        this.partnerId = (this.alivePartners.length > 0) ? this.alivePartners[0]._id : "";
        this.isTerminated = false;
        this.updateProducts();
    },
    methods: {
        updateProducts() {
            this.centerTotalCounts = {};
            this.filterStock = '재고유무';
            this.sortType = '이름순';
            this.$event.call("openLoading");
            this.$api.getProductList(this.partnerId, (resData) => {
                this.$event.call("closeLoading");
                if (resData.error) {
                    alert(resData.error.message);
                } else {
                    this.products = resData.products;

                    for (const product of this.products)
                    {
                        product.isTerminated = product.isTerminated ? true : false;
                        product.hasStock = false;
                        product.totalCount = 0;

                        for (const center of this.centers)
                        {
                            if (center && center._id)
                            {
                                if (!product.centerStocks[center._id]) product.centerStocks[center._id] = {};
                                if (!product.centerStocks[center._id].count) product.centerStocks[center._id].count = 0;
                                if (product.centerStocks[center._id].count != 0) product.hasStock = true;
                                product.totalCount += product.centerStocks[center._id].count;
                            }
                        }
                    }
                    
                    for (const center of this.centers) {
                        let sum = 0;
                        for (const product of this.products) {
                            sum += product.centerStocks[center._id].count;
                        }
                        this.centerTotalCounts[center._id] = sum;
                    }
                }
            });
        },
        newProduct() {
            this.$event.call("newProduct", this.partnerId, this.updateProducts);
        },
        editProduct(product) {
            this.selected = product;
            this.$event.call("editProduct", this.partnerId, product, this.updateProducts);
        },
        removeProduct(product) {
            this.$event.call("openPopup", "상품을 삭제하시겠습니까?", "", () => {
                this.$api.removeProduct(product._id, (resData) => {
                    if (resData.error) {
                        alert(resData.error.message);
                    } else {
                        this.updateProducts();
                    }
                });
            });
        },
        sort() {
            
        },
        openProductStockLog() { this.$event.call("openProductStockLog", this.partnerId, this.products); },
        setStock() { this.$event.call("setStock", this.partnerId, this.updateProducts); },
        addStock() { this.$event.call("addStock", this.partnerId, this.products, this.updateProducts); },
        removeStock() { this.$event.call("removeStock", this.partnerId, this.products, this.updateProducts); },
        confirmAddStock() { this.$event.call("confirmAddStock", this.partnerId, this.updateProducts); },
        confirmRemoveStock() { this.$event.call("confirmRemoveStock", this.partnerId, this.updateProducts); },
        transferStock(product) { this.$event.call("transferStock", product, this.updateProducts); },
        confirmStocks() {
            this.$event.call("openLoading");
            this.$api.confirmStocks(this.partnerId, (resData) => {
                this.$event.call("closeLoading");
                if (resData.error) {
                    alert(resData.error.message);
                } else {
                    this.updateProducts();
                }
            });
        },
        getProducts() {
            const array = [];
            switch (this.filterStock) {
                default: for (const product of this.products) if (product.isTerminated == this.isTerminated) array.push(product); break;
                case '재고유': for (const product of this.products) if (product.isTerminated == this.isTerminated && product.hasStock) array.push(product); break;
                case '재고무': for (const product of this.products) if (product.isTerminated == this.isTerminated && !product.hasStock) array.push(product); break;
            }
            switch (this.sortType) {
                case '이름순': return array.sort((a, b) => a.name < b.name ? -1 : 1);
                case '이름역순': return array.sort((a, b) => a.name > b.name ? -1 : 1);
                case '날짜순': return array.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));
                case '날짜역순': return array.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
            }
            return array;
        },
        getAllTotalCount()
        {
            let sum = 0;
            for (const center of this.centers) {
                sum += this.centerTotalCounts[center._id];
            }
            return sum;
        }, 
        getPartner(_partnerId)
        {
            for (const partner of this.partners)
            {
                if (partner._id == _partnerId) return partner;
            }
            return null;
        },
        getAlivePartners()
        {
            const array = [];
            for (const partner of this.partners)
            {
                if (!partner.isTerminated) array.push(partner);
            }
            return array;
        },
        getCenters()
        {
            const array = [];
            for (const center of this.centers)
            {
                if (!center.isTerminated)
                    array.push(center);
            }
            return array;
        },
        download()
        {
            const partner = this.getPartner(this.partnerId);
            this.$excel.downloadProduct(this, partner.name);
        },
        downloadAll()
        {
            this.$event.call("openLoading");

            this.$api.getAllProductList((resData) =>
            {
                this.$event.call("closeLoading");
                if (resData.error) {
                    alert(resData.error.message);
                } else {
                    this.$excel.downloadAllProducts(this, resData.allProducts);
                }
            });
        },
    },
    computed: {
        user: function() { return this.$store.getters.user; },
        isHeader: function() {return this.$store.getters.isHeader; },
        isPartner: function() {return this.$store.getters.isPartner; },
        isCenter: function() {return this.$store.getters.isCenter; },
        partners: function() { return this.$store.getters.partners; },
        centers: function() {return this.$store.getters.centers; },
    },
}
</script>

<style>
#product_main {
    margin-top:15px;
}
#product_main .segment {
    min-width: 1200px;
    min-height: 800px;
}
#product_main .ui.text.menu {
    margin: 0;
    width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/ProductMain.vue